export default __webpack_public_path__ + "static/media/weaving.f37271a9.webp";